import styles from '../css/RoleBadge.module.css';

export function getPrimaryRole(roles = []) {
  if (!Array.isArray(roles)) return null;
  if (roles.includes('admin')) return 'admin';
  if (roles.includes('moderator')) return 'moderator';
  return null;
}

const TOOLTIP = {
  admin: 'Администратор',
  moderator: 'Модератор',
};

const RoleBadge = ({ role }) => {
  if (!role) return null;

  const badgeClass = role === 'admin' ? styles.badgeAdmin : styles.badgeModerator;

  return (
    <span
      className={`${styles.badge} ${badgeClass}`}
      data-tooltip={TOOLTIP[role]}
      aria-label={TOOLTIP[role]}
    >
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" stroke="#fff" strokeWidth="1.5" />
        <polyline points="5,8 7,10.5 11,5.5" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  );
};

export default RoleBadge;
